"use strict";
/**
 * Declarative flowKind overlays for TS action packs.
 * Edit this file to configure packs without touching every action row.
 *
 * Stack order: byId maps first (precise), then bulk where() rules, then defaults.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureDefaultActions1 = exports.configureReuseActions = exports.configureBikeActions = exports.configureActions2 = exports.reusePackSteps = exports.bikePackSteps = exports.actions2ById = void 0;
var actionPackConfig_1 = require("./actionPackConfig");
var T_OPEN = {
    flowKind: 'T',
    timeStyle: 'duration',
    opensFocus: true,
    closesPreviousT: true,
};
var I_NONE = { flowKind: 'I', timeStyle: 'none', planningKind: 'note' };
var L_STAMP = { flowKind: 'L', timeStyle: 'stamp', planningKind: 'none' };
/**
 * Escalated = urgency / follow-up modifier (not a human timer).
 * flowKind I → no Focus S/T side effects.
 * createsSchedule → pnSchedule=1; server puts Escalated at top of backlog rank.
 */
var ESCALATE = {
    flowKind: 'I',
    timeStyle: 'none',
    planningKind: 'escalate',
    createsSchedule: true,
};
/** Precise overrides for actions2.ts by id */
exports.actions2ById = {
    // Impact / notes (Activity taxonomy but not human timers)
    400100: I_NONE,
    400110: I_NONE,
    400200: I_NONE,
    400210: I_NONE,
    410100: I_NONE,
    410110: I_NONE,
    500100: I_NONE,
    // Inventory / logistics
    50000100: L_STAMP,
    50008280: L_STAMP,
    50008290: L_STAMP,
    50018200: L_STAMP,
    // Generic
    1300100: I_NONE,
    1300110: I_NONE,
    1300200: I_NONE,
    1301200: T_OPEN,
    1301300: ESCALATE,
    1301310: ESCALATE,
    1301400: T_OPEN,
    1301401: I_NONE,
    1302200: T_OPEN,
    1300300: I_NONE,
    1300400: I_NONE,
    2300100: T_OPEN, // Support / assist
};
/** Bike pack: Audit = note; Escalated = urgency→schedule; Logistics = L; Activity = T */
exports.bikePackSteps = [
    (0, actionPackConfig_1.whereTaskGroup)('Audit', I_NONE),
    (0, actionPackConfig_1.whereTaskGroup)('Escalated', ESCALATE),
    (0, actionPackConfig_1.whereTaskGroup)('Info', I_NONE),
    (0, actionPackConfig_1.where)(function (a) {
        var _a, _b, _c;
        return (((_a = a.auditRow) === null || _a === void 0 ? void 0 : _a.taskGroup) || '') === 'Logistics' &&
            ((((_b = a.auditRow) === null || _b === void 0 ? void 0 : _b.topicGroup) || '') === 'Battery' ||
                /Battery|Exchanged|Installed|Removed/i.test("".concat(((_c = a.auditRow) === null || _c === void 0 ? void 0 : _c.topicDetail) || '', " ").concat(a.caption || '')));
    }, L_STAMP),
    (0, actionPackConfig_1.whereTaskGroup)('Logistics', L_STAMP),
    (0, actionPackConfig_1.whereTaskGroup)('Inventory', L_STAMP),
    // Maintenance activity / test ride = human field time
    (0, actionPackConfig_1.whereTaskGroup)('Activity', T_OPEN),
    // Anything still unset stays I (safe)
    (0, actionPackConfig_1.defaultFlowWhenMissing)(I_NONE),
];
exports.reusePackSteps = [
    (0, actionPackConfig_1.whereTaskGroup)('Logistics', L_STAMP),
    (0, actionPackConfig_1.whereTaskGroup)('Inventory', L_STAMP),
    (0, actionPackConfig_1.whereTopicGroup)('Available', L_STAMP),
    (0, actionPackConfig_1.whereTopicGroup)('Received', L_STAMP),
    (0, actionPackConfig_1.whereTopicGroup)('Picking', L_STAMP),
    (0, actionPackConfig_1.defaultFlowWhenMissing)(I_NONE),
];
function configureActions2(raw) {
    return (0, actionPackConfig_1.configureActionPack)(raw, [(0, actionPackConfig_1.byId)(exports.actions2ById), (0, actionPackConfig_1.defaultFlowWhenMissing)(I_NONE)]);
}
exports.configureActions2 = configureActions2;
function configureBikeActions(raw) {
    return (0, actionPackConfig_1.configureActionPack)(raw, exports.bikePackSteps);
}
exports.configureBikeActions = configureBikeActions;
function configureReuseActions(raw) {
    return (0, actionPackConfig_1.configureActionPack)(raw, exports.reusePackSteps);
}
exports.configureReuseActions = configureReuseActions;
/** Identity for packs already fully annotated inline (defaultActions1). */
function configureDefaultActions1(raw) {
    return (0, actionPackConfig_1.configureActionPack)(raw, [
        // Only fill gaps; do not override hand-set flowKind on session/travel/etc.
        (0, actionPackConfig_1.defaultFlowWhenMissing)(I_NONE),
    ]);
}
exports.configureDefaultActions1 = configureDefaultActions1;
